import React from 'react';
import { Link, Flex, Title, PhoneAsleepSVG } from '@bb/elements-web';
import { StyledCard, StyledText } from './styledComponents';

export default function SingleAccessNotFoundCard() {
  return (
    <StyledCard $centerText $noPadding>
      <Flex vertical gap={8} align="center">
        <PhoneAsleepSVG />
        <Title
          dataCy="single-access-not-found-title"
          level={4}
          textAlign="center"
          margin={0}
        >
          This invitation link has expired.
        </Title>
        <StyledText $secondary size="large" $alignCenter>
          Please contact the user granting access to be re-invited.
        </StyledText>
        <Link size="large" href={window.location.origin}>
          Return to Login
        </Link>
      </Flex>
    </StyledCard>
  );
}
